import React from "react";
import "./SponsorsPage.css";
import alteredSecurityLogo from "../img/Altered_security.webp";
import apisecLogo from "../img/apisec-logo.png";
import caidoLogo from "../img/caido.webp";
import hackersMeetupLogo from "../img/The _Hackers_Meetup_Nagpur.png";
import cyberxLogo from "../img/CyberX.jpeg";
import shahOverseasLogo from "../img/shah_overseas-logo.png";
import modernSecurityLogo from "../img/ModernSecurity.jpeg";
import enciphersLogo from "../img/Enciphers.png";
import ecCouncilLogo from "../img/ec-council.jpg";

const SponsorsPage = () => {
  return (
    <div className="sponsors-page">
      <div className="sponsors-content">
        <div className="sponsors-header">
          <h1>OUR SPONSORS</h1>
        </div>

        <div className="sponsors-section">
          <h2 className="section-heading">PRIZE SPONSORS</h2>
          <div className="sponsors-grid">
            <a
              href="https://www.alteredsecurity.com/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={alteredSecurityLogo}
                  alt="Altered Security Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">Altered Security</h3>
              <p className="sponsor-description">
                Supporting excellence in cybersecurity education
              </p>
            </a>
            <a
              href="https://www.apisecuniversity.com/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={apisecLogo}
                  alt="APISec University Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">APISec University</h3>
              <p className="sponsor-description">
                Empowering the next generation of security professionals
              </p>
            </a>
            <a
              href="https://caido.io/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={caidoLogo}
                  alt="Caido Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">Caido</h3>
              <p className="sponsor-description">
                Innovation in cybersecurity training
              </p>
            </a>
          </div>
        </div>

        <div className="sponsors-section">
          <h2 className="section-heading">LEARNING PARTNERS</h2>
          <div className="sponsors-grid">
            <a
              href="https://www.modernsecurity.io/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={modernSecurityLogo}
                  alt="Modern Security Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">Modern Security</h3>
              <p className="sponsor-description">
                Advancing cybersecurity education and training
              </p>
            </a>
            <a
              href="https://www.enciphers.com/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={enciphersLogo}
                  alt="Enciphers Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">Enciphers</h3>
              <p className="sponsor-description">
                Expert-led security training and research
              </p>
            </a>
            <a
              href="https://www.eccouncil.org/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={ecCouncilLogo}
                  alt="EC-Council Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">EC-Council</h3>
              <p className="sponsor-description">
                World leader in cybersecurity certifications
              </p>
            </a>
          </div>
        </div>

        <div className="sponsors-section">
          <h2 className="section-heading">COMMUNITY PARTNER</h2>
          <div className="sponsors-grid">
            <a
              href="https://thehackersmeetup.org/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={hackersMeetupLogo}
                  alt="The Hacker's Meetup Nagpur Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">The Hacker's Meetup Nagpur</h3>
              <p className="sponsor-description">
                Building a stronger cybersecurity community together
              </p>
            </a>
            <a
              href="https://www.cyberxindia.com/"
              className="sponsor-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="sponsor-logo">
                <img
                  src={cyberxLogo}
                  alt="CyberX Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">CyberX</h3>
              <p className="sponsor-description">
                Empowering the cybersecurity community
              </p>
            </a>
          </div>
        </div>

        <div className="sponsors-section">
          <h2 className="section-heading">OUR PARTNERS</h2>
          <div className="sponsors-grid">
            <div className="sponsor-card">
              <div className="sponsor-logo">
                <img
                  src={shahOverseasLogo}
                  alt="Shah Overseas Logo"
                  className="sponsor-image"
                />
              </div>
              <h3 className="sponsor-name">Shah Overseas</h3>
              <p className="sponsor-description">
                Strategic alliance for masters in cybersecurity programs
              </p>
            </div>
          </div>
        </div>

        <div className="sponsors-cta">
          <h3>INTERESTED IN SPONSORING?</h3>
          <p>Join us in supporting the future of cybersecurity</p>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=phoenixcybersec008@gmail.com&su=Sponsorship Inquiry - EncipherX 4.0"
            className="contact-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            CONTACT US
          </a>
        </div>
      </div>
    </div>
  );
};

export default SponsorsPage;
